/**
 * Extrae mensaje legible de respuestas JSON tipo Laravel (message o errors por campo).
 */
function isLikelyNetworkFailure(err) {
  if (err?.response) return false;
  const msg = String(err?.message || "").toLowerCase();
  if (msg.includes("timeout")) return false;
  const code = err?.code;
  const raw = String(err?.message || "");
  return (
    code === "ERR_NETWORK" ||
    raw === "Network Error" ||
    raw.includes("Network Error") ||
    raw.includes("Failed to fetch")
  );
}

export function formatApiError(err, fallback = "Ha ocurrido un error") {
  if (!err?.response) {
    const msg = String(err?.message || "").toLowerCase();
    if (msg.includes("timeout")) {
      return "El servidor tardó demasiado en responder. Inténtalo de nuevo.";
    }
  }
  if (isLikelyNetworkFailure(err)) {
    return "No se pudo conectar con el servidor. Revisa tu conexión. Si el fallo es solo aquí, suele deberse a CORS en el API (debe permitir GET desde este dominio).";
  }

  const data = err?.response?.data;
  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message.trim()) {
      return data.message;
    }
    const errors = data.errors;
    if (errors && typeof errors === "object") {
      const firstKey = Object.keys(errors)[0];
      const firstVal = firstKey != null ? errors[firstKey] : null;
      const msg = Array.isArray(firstVal) ? firstVal[0] : firstVal;
      if (msg != null && String(msg).trim()) return String(msg);
    }
  }
  const m = err?.message;
  if (typeof m === "string" && m.trim()) return m;
  return fallback;
}

/** Mapa campo → primer mensaje (validación 422). */
export function getFieldErrors(err) {
  const errors = err?.response?.data?.errors;
  if (!errors || typeof errors !== "object") return {};
  const out = {};
  for (const key of Object.keys(errors)) {
    const val = errors[key];
    out[key] = Array.isArray(val) ? val[0] : val;
  }
  return out;
}
